import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-67c945b9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "center" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Modificar contraseña", -1))

import { ref, computed } from "vue";
import ModalSuccess from "../Commons/ModalSuccess.vue";
import ModalError from "../Commons/ModalError.vue";
import { cambiarPass } from "@/services/UsuariosService";
import { UsuarioCambioPassDTO } from "@/interfaces/Usuario";
import { useAuth } from "@/composables/useAuth";


export default /*#__PURE__*/_defineComponent({
  __name: 'ModalCambiarPass',
  emits: ["close"],
  setup(__props, { emit: __emit }) {

const emit = __emit;

const show = ref<boolean>(true);
const oldPass = ref<string>("");
const newPass1 = ref<string>("");
const newPass2 = ref<string>("");

const showSuccessModal = ref<boolean>(false);
const showErrorModal = ref<boolean>(false);
const isLoading = ref<boolean>(false);

const { getidUsuario } = useAuth();
const idUsuario = ref<string | null>(getidUsuario.value);

const close = () => {
  show.value = false;
  emit("close");
};

// Función para manejar el cierre de los modales de éxito y error
const handleModalClose = (value: boolean) => {
  if (!value) {
    close();
  }
};

// Validaciones
const requiredRule = (value: string) => !!value || "Este campo es obligatorio";
const passwordRule = (value: string) =>
  value.length >= 6 || "La contraseña debe tener al menos 6 caracteres";
const passwordMatchRule = (value: string) =>
  value === newPass1.value || "Las contraseñas no coinciden";

const isFormValid = computed(() => {
  return (
    oldPass.value &&
    newPass1.value &&
    newPass2.value &&
    newPass1.value === newPass2.value
  );
});

// Función para cambiar la contraseña
const cambiar = async () => {
  if (isFormValid.value) {
    try {
      const body: UsuarioCambioPassDTO = {
        idUsuario: parseInt(idUsuario.value!),
        oldPass: oldPass.value,
        newPass: newPass1.value,
      };

      isLoading.value = true;
      await cambiarPass(body);
      showSuccessModal.value = true;
    } catch (error) {
      console.error(error);
      showErrorModal.value = true;
    } finally {
      isLoading.value = false;
    }
  }
};

return (_ctx: any,_cache: any) => {
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list_item_content = _resolveComponent("v-list-item-content")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_dialog, {
      modelValue: show.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((show).value = $event)),
      "max-width": "800px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, { class: "modal-title" }, {
              default: _withCtx(() => [
                _hoisted_2,
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  icon: "",
                  onClick: close,
                  class: "close-button"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, null, {
                      default: _withCtx(() => [
                        _createTextVNode("mdi-close")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_divider),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_list, { dense: "" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_list_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_text_field, {
                          modelValue: oldPass.value,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((oldPass).value = $event)),
                          label: "Antigua contraseña",
                          type: "password",
                          required: "",
                          rules: [requiredRule]
                        }, null, 8, ["modelValue", "rules"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_list_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_text_field, {
                          modelValue: newPass1.value,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((newPass1).value = $event)),
                          label: "Nueva contraseña",
                          type: "password",
                          required: "",
                          rules: [requiredRule, passwordRule]
                        }, null, 8, ["modelValue", "rules"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_list_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_text_field, {
                          modelValue: newPass2.value,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((newPass2).value = $event)),
                          label: "Repite la nueva contraseña",
                          type: "password",
                          required: "",
                          rules: [requiredRule, passwordMatchRule]
                        }, null, 8, ["modelValue", "rules"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_list_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_list_item_content, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_btn, {
                              loading: isLoading.value,
                              color: "primary",
                              variant: "tonal",
                              onClick: cambiar,
                              disabled: isLoading.value || !isFormValid.value
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" Cambiar contraseña ")
                              ]),
                              _: 1
                            }, 8, ["loading", "disabled"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(ModalSuccess, {
      isVisible: showSuccessModal.value,
      message: "Se ha modificado la contraseña correctamente.",
      "onUpdate:isVisible": handleModalClose
    }, null, 8, ["isVisible"]),
    _createVNode(ModalError, {
      isVisible: showErrorModal.value,
      message: "No se ha podido modificar la contraseña. Contacta con el administrador.",
      "onUpdate:isVisible": handleModalClose
    }, null, 8, ["isVisible"])
  ]))
}
}

})